import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { environment } from '../../../../../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { TypeEmployeeService } from '../../../../../../services/type-employee/type-employee.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { JobTitleService } from '../../../../../../services/jobtitle/jobtitle.service';
import { ConfigService } from '../../../../../../services/config/config.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../../../const/date-format';
import { Moment } from 'moment';
import { AuthenticationService } from '../../../../../../services/authentication/authentication.service';

import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';

@Component({
    selector: 'fuse-teacher-attendance-sheet-configuration',
    templateUrl: './teacher-attendance-sheet-configuration.component.html',
    styleUrls: ['./teacher-attendance-sheet-configuration.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'es-ES'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
    animations: fuseAnimations
})
export class TeacherAttendanceSheetConfigurationComponent implements OnInit, AfterViewInit, OnDestroy {
    @BlockUI() blockUI: NgBlockUI;
    formGroup;
    dateFormControl;

    public shifts = [];
    minDate = new Date(1930, 0, 1);
    mask = [ /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    maskedInputControllerAttendanceDate;
    @ViewChild('attendanceDate', { read: ViewContainerRef }) public attendanceDate;

    weekendDaysFilter = (date: Moment) => date.day() !== 0 && date.day() !== 6;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<TeacherAttendanceSheetConfigurationComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        public typeEmployeeService: TypeEmployeeService,
        public shiftService: ShiftService,
        private jobTitleService: JobTitleService,
        private configService: ConfigService,
        private authenticationService: AuthenticationService
    ) {
        console.log('FuseAddStudentComponent > data', data);
        this.initializeFormControlValidators();
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        Observable.combineLatest(
            this.shiftService.getAll()
        ).subscribe(([shifts]) => {
            this.shifts = shifts.map(e => {
                return {Id: e.Id, Description: e.Description, Checked: false};
            });
            this.blockUI.stop();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    ngOnDestroy() {
        this.maskedInputControllerAttendanceDate.destroy();
    }


    ngAfterViewInit() {
        setTimeout(() => {
            this.maskedInputControllerAttendanceDate = textMask.maskInput({
                inputElement: this.attendanceDate.element.nativeElement,
                mask: this.mask
            });
        });
    }

    initializeFormControlValidators() {
        this.formGroup = this.fb.group({
            dateFormControl: ['', [Validators.required]],
        });
    }

    required(list) {
        return list.filter(e => e.Checked).length === 0;
    }

    save() {
        const date = this.data.HireDate.month() + 1 + '-' + this.data.HireDate.date() + '-' + this.data.HireDate.year();
        const shifts = this.shifts.filter(e => e.Checked).map(e => e.Id);
        window.open(environment.backendUri + 'report/TeacherAttendanceSheet/' + this.authenticationService.getAuthData().SchoolYear.Id + '/' + shifts + '/' + date, '_new');
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/employees/components/teacher-attendance-sheet-configuration/teacher-attendance-sheet-configuration.component.ts